<template>
    <div>
      <div>
        <div v-if="comments" class="flex items-center justify-between gap-2">
            <span id="comment-text">{{ comments }}</span>
            <vx-tooltip text="Editar o ver comentario" placement="top">
              <vs-button @click="onPopupComments($event)" color="dark" type="border" icon="edit" size="small" :disabled="!checkEditingPermissions()"></vs-button>
            </vx-tooltip>
        </div>
        <div v-else>
            <p class="text-grey">Sin comentarios</p>
        </div>
      </div>
      <vs-popup :title="title" :active.sync="popupActive" class="content-display-comments">
        <div class="flex flex-col gap-2">
          <vs-textarea 
            v-model="editingComments"
            :rows="7" 
            counter="240"
            :maxlength="240"
            :disabled="!checkEditingPermissions()"
          />
          <div class="flex justify-end gap-2">
            <vs-button @click="onPopupComments($event)" color="grey" type="border" size="small" class="hover:bg-grey-light">Cancelar</vs-button>
            <vs-button @click="updateComments()" color="success" size="small" :disabled="loading || !checkEditingPermissions()">Guardar</vs-button>
          </div>
        </div>
      </vs-popup>
    </div>
  </template>

  <style>

    #comment-text {
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  </style>
  
  <script>
  import Vue from 'vue'
  import appConfig from '@/../appConfig.js'
  import { checkPermissions } from '@/utils/security'
import { PERMISSIONS } from '../../utils/strings'
  
  export default Vue.extend({
    data () {
      return {
        comments: '',
        editingComments: '',
        popupActive: false,
        campaignId: null,
        title: null,
        loading: false
      }
    },
    beforeMount () {
      this.comments = this.params.value
      this.campaignId = this.params.colDef.cellRendererParams.campaignId(this.params)
      this.title = `Comentarios de la campaña: ${this.campaignId}`
    //   this.title = `Campaña ID: ${this.rowValue.id}`
    },
    watch: {
      loading (newVal) {
        if (newVal) {
          this.$vs.notify({
            title: 'Actualizando',
            text: `Actualizando comentario de la campaña ${this.campaignId}...`,
            color: 'dark',
            duration: 0,
            loading: true
          })
        }
      },
    },
    methods: {
      // gets called whenever the user gets the cell to refresh
      refresh (params) {
        this.comments = this.getValueToDisplay(params)
      },
      checkEditingPermissions () {
        return checkPermissions([PERMISSIONS.EDIT_CAMPAIGN_COMMENTS])
      },
      onPopupComments (event) {
        event.stopPropagation()
        this.popupActive = !this.popupActive
        if (this.popupActive) {
          this.editingComments = this.comments
        }
      },
  
      getValueToDisplay (params) {
        return params.value
      },
      checkCommentLength (comment) {
        switch (true) {
          case comment.length > 240:
            return 'El comentario no puede tener más de 240 caracteres'
          case comment.length < 1:
            return 'El comentario no puede estar vacío'
          default:
            return null
        }
      },
  
      updateComments () {
        const hasErrorLength = this.checkCommentLength(this.editingComments)
        if (hasErrorLength) {
          this.$vs.notify({
            title: 'Error',
            text: hasErrorLength,
            color: 'danger'
          })

          return
        }

        this.loading = true
        this.$http.put(`${appConfig.apiUrl}/campaigns/${this.campaignId}/comments`, {
          comments: this.editingComments
        })
          .then(() => {
            this.comments = this.editingComments
  
            this.$vs.notify({
              title: this.title,
              text: `Comentario actualizado`,
              color: 'success'
            })
          })
          .catch((error) => {
            console.log(error)
            this.$vs.notify({
              title: 'Error',
              text: error.message,
              color: 'danger'
            })
          })
          .then(() => {
            // always executed
            this.loading = false
            this.popupActive = !this.popupActive
          })
      }
    }
  })
  </script>